import { IonCol, IonLabel, IonRow } from '@ionic/react'
import React from 'react'
import '../header/Header.component.css'
import { getStyleForPHI, IPHIComponent } from '../../../components/phi/phi.component'

export interface RowDetails {
  label?: string
  value: string
}

export interface IHeaderRow extends IPHIComponent {
  rowDetails: RowDetails
  key: string
}

const HeaderRow: React.FC<IHeaderRow> = (props: IHeaderRow) => {
  const { rowDetails, isPHI } = props
  return (
    <>
      {rowDetails.label != '' && (
        <IonRow qa-id='item_list_header_row' className='header-row'>
          {rowDetails.label && (
            <IonCol qa-id='item_list_header_column' size='6' className='header-col'>
              <IonLabel qa-id='item_list_header_row_label' className='header-label'>
                {rowDetails.label}:
              </IonLabel>
            </IonCol>
          )}
          <IonCol>
            <IonLabel
              data-private={isPHI}
              qa-id='item_list_header_row_value'
              style={getStyleForPHI(isPHI)}
              className='header-value'>
              {rowDetails.value}
            </IonLabel>
          </IonCol>
        </IonRow>
      )}
    </>
  )
}

export default HeaderRow
